/** @file Vertex adjacency from triangle edges, as ascending neighbour lists (deterministic smoothing). */

/** neighbors[v] = vertices sharing a triangle edge with v, ascending; indices >= count are ignored. */
export function meshNeighbors(count: number, triangles: readonly number[]): number[][] {
  const sets = Array.from({ length: count }, () => new Set<number>());
  const link = (a: number, b: number): void => {
    if (a === b || a >= count || b >= count) return;
    sets[a]?.add(b);
    sets[b]?.add(a);
  };
  for (let t = 0; t + 2 < triangles.length; t += 3) {
    const a = triangles[t] ?? 0;
    const b = triangles[t + 1] ?? 0;
    const c = triangles[t + 2] ?? 0;
    link(a, b);
    link(b, c);
    link(c, a);
  }
  return sets.map((s) => [...s].sort((x, y) => x - y));
}
